import { BaseEntityComponent } from "@bndes/bndes-ux4/bndes-angular-utils";
import { UntypedFormGroup } from '@angular/forms';
import { ModalidadeGarantia, HistoricoModalidadeGarantia, LabelTipoOutraGarantia} from '../../../model/modalidade_garantia.model';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from "@angular/core";
import { ModalidadeGarantiaService } from "../modalidade-garantia.service";


@Component({
    selector: 'app-modalidade-garantia-historico',
    templateUrl: './modalidade-garantia-historico.component.html',
    standalone: false
})

export class ModalidadeGarantiaHistoricoComponent extends BaseEntityComponent<ModalidadeGarantia> implements OnInit {

  @Input() public modalidade: ModalidadeGarantia;
  @Input() public historico: HistoricoModalidadeGarantia;
  @Output() public fechaHistorico = new EventEmitter()
  public labelsOutraGarantia = LabelTipoOutraGarantia;
  formHistoricoModalidade: UntypedFormGroup = null;

  constructor(private modalidadeGarantiaService: ModalidadeGarantiaService,
              protected injector: Injector,) {
    super(modalidadeGarantiaService);       
  }

  ngOnInit(): void {

  }

  public labelOutraGarantia(item) {
    return this.labelsOutraGarantia.get(item);
  }

  public fecharHistorico() {
    this.fechaHistorico.emit()
  }



}
